// Auto-generated entry point - DO NOT EDIT
// Generated at: 2026-01-09T18:12:56.889Z

// Import HTMX
import htmx from 'htmx.org';

// Make HTMX available globally
window.htmx = htmx;

// Initialize HTMX
document.addEventListener('DOMContentLoaded', () => {
    console.log('HTMX version:', htmx.version);
});

// Component imports
import * as addloanModule from './public_html/src/components/addloan/js/main.js';
import * as blogModule from './public_html/src/components/blog/js/main.js';
import * as globalModule from './public_html/src/components/global/js/main.js';
import * as homepageModule from './public_html/src/components/homepage/js/main.js';
import * as viewloansModule from './public_html/src/components/viewloans/js/main.js';

// Component registry
const components = {
    'addloan': addloanModule,
    'blog': blogModule,
    'global': globalModule,
    'homepage': homepageModule,
    'viewloans': viewloansModule,
};

// Initialize components based on current page/route
document.addEventListener('DOMContentLoaded', () => {
    // Get current route from URL path
    const path = window.location.pathname;
    const routeName = path === '/' ? 'homepage' : path.substring(1).split('/')[0];

    console.log('Current route:', routeName);

    // Initialize global components (if any)
    if (components.global && typeof components.global.init === 'function') {
        console.log('Initializing global component');
        components.global.init();
    }

    // Initialize route-specific component
    if (components[routeName] && typeof components[routeName].init === 'function') {
        console.log('Initializing component:', routeName);
        components[routeName].init();
    }

    // Store components globally for debugging
    window.appComponents = components;
});

// Export for potential use by other scripts
export { components, htmx };
